"use client";

import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";

export function AppointmentCreationUnavailable({ onClose }: { onClose: () => void }) {
  const t = useTranslations("appointments.appointmentForm");
  const tc = useTranslations("common");
  return (
    <div className="flex flex-1 flex-col items-start gap-4 p-6" data-slot="appointment-creation-unavailable">
      <p role="status" className="text-sm text-muted-foreground">{t("creationUnavailable")}</p>
      <Button type="button" variant="outline" onClick={onClose}>{tc("close")}</Button>
    </div>
  );
}
